/*
 *
 *  remotes
 *
 */

import api from "../../helpers";

/**
 *
 * @param {string} metaData
 * @returns
 */

export async function loadBirthdayListDetails(searchFilter) {
  return await api
    .post(`/auth/attendance/birthday`, searchFilter)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}
export async function loadDashboardAttandanceAPI(searchFilter) {
  return await api
    .post(`/auth/attendance/getattendance`, searchFilter)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}
export async function loadDashboardCheckinOutAPI(searchFilter) {
  return await api
    .post(`/protected/getaction`, searchFilter)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}
export async function loadHolidayListDetails(searchFilter) {
  return await api
    .post(`/protected/getholiday`, searchFilter)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}
export async function loadYearlyLeaveAPI(searchFilter) {
  return await api
    .post(`/auth/yearlyleaves`, searchFilter)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}
export async function loadDailyPercentangeAPI(searchFilter) {
  return await api
    .post(`/auth/dailypercentage`, searchFilter)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}
export async function loadWeeklyPercentangeAPI(searchFilter) {
  return await api
    .post(`/auth/weeklypercentage`, searchFilter)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

export async function loadMonthlyPercentangeAPI(searchFilter) {
  return await api
    .post(`/auth/monthlypercentage`, searchFilter)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}
export async function loadEmployeeStatusAPI(searchFilter) {
  return await api
    .post(`/auth/monthlypercentage`, searchFilter)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}
export async function loadAttendanceOverviewAPI(searchFilter) {
  return await api
    .post(`/auth/attendance/getattendancedetails`, searchFilter)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}
export async function loadDepartmentAPI(searchFilter) {
  return await api
    .post(`/protected/getdept`, searchFilter)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

export async function loadAttendanceTodayOverviewAPI(searchFilter) {
  return await api
    .post(`auth/attendance/attendanceoverview`, searchFilter)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}
export async function loadAttendanceThisWeekOverviewAPI(searchFilter) {
  return await api
    .post(`auth/attendance/weeklyoverview`, searchFilter)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}
export async function loadAttendanceThisMonthOverviewAPI(searchFilter) {
  return await api
    .post(`auth/attendance/monthlyoverview`, searchFilter)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}
export async function loadLateAPI(searchFilter) {
  return await api
    .post(`auth/attendance/latelogin`, searchFilter)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

export async function loadEmployeeTypeAPI(searchFilter) {
  return await api
    .post(`auth/employee/employeetypepercentage`, searchFilter)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}
const remotes = {
  loadBirthdayListDetails,
  loadDashboardAttandanceAPI,
  loadDashboardCheckinOutAPI,
  loadYearlyLeaveAPI,
  loadHolidayListDetails,
  loadDailyPercentangeAPI,
  loadWeeklyPercentangeAPI,
  loadMonthlyPercentangeAPI,
  loadEmployeeStatusAPI,
  loadAttendanceOverviewAPI,
  loadAttendanceTodayOverviewAPI,
  loadAttendanceThisWeekOverviewAPI,
  loadAttendanceThisMonthOverviewAPI,
  loadLateAPI,
  loadEmployeeTypeAPI
};

export default remotes;
